import queryString from "query-string";

import ReactGA from "react-ga";

export const checkParams = (paramURL, location) => {
  const param = queryString.parse(location.search)[paramURL];

  return param;
};

export const groupBy = (arrayToGroupBy, parameterToGroupBy) => {
  if (arrayToGroupBy) {
    return arrayToGroupBy.reduce((result, cell) => {
      if (!result[cell[parameterToGroupBy]])
        result[cell[parameterToGroupBy]] = [];
      result[cell[parameterToGroupBy]].push(cell);
      return result;
    }, {});
  }
};

export const filterObjectsInArray = (array, param, value) => {
  const arrayFiltered = array.filter(obj => {
    return obj[param] === value;
  });

  return arrayFiltered;
};

export const findValueInArray = (array, valueToSearch) => {
  let itemFinded = array.find(item => {
    return item === valueToSearch.toString();
  });
  return itemFinded;
};

export const newArrayJustWithValues = (array, param) => {
  if (array) {
    return array.map(item => item[param]);
  }
  return null;
};

export const hexToRgb = hex => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : null;
};

export const colorTertiaryForPrint = (location, state) => {
  let rgba;

  if (location && location.search) {
    const URLParams = queryString.parse(location.search);

    if (URLParams && URLParams["tertiary-color"]) {
      const colorRowIndexes = URLParams["tertiary-color"].split(",");
      const colorRowIndex = colorRowIndexes[0];
      const colorColIndex = colorRowIndexes[1];
      const colorsTertiary = state.colorsTertiary;

      if (colorsTertiary && colorsTertiary.length > 0) {
        rgba =
          colorsTertiary[colorRowIndex] &&
          colorsTertiary[colorRowIndex].wizard_colors_tertiary_repeater[
            colorColIndex
          ] &&
          colorsTertiary[colorRowIndex].wizard_colors_tertiary_repeater[
            colorColIndex
          ].wizard_color_tertiary_picker;
        rgba = hexToRgb(rgba);
        if (rgba) rgba = `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, 1)`;
      }
    }
  }

  return rgba;
};

export const newSearchURL = (oldURL, newURL, location) => {
  const { search } = location;

  const newSearchURL = search.replace(oldURL, newURL);

  return newSearchURL;
};

export const getClosest = (elem, selector) => {
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.oMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      function(s) {
        let matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {}
        return i > -1;
      };
  }
  for (; elem && elem !== document; elem = elem.parentNode) {
    if (elem.matches(selector)) return elem;
  }
  return null;
};

export const getSiblings = elem => {
  var siblings = [];
  var sibling = elem.parentNode.firstChild;
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== elem) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
};


export const initGA = trackingID => {
  ReactGA.initialize(trackingID);
};

export const PageView = () => {
  ReactGA.pageview(window.location.pathname + window.location.search);
};

/**
 * Event - Add custom tracking event.
 * @param {string} category 
 * @param {string} action 
 * @param {string} label 
 */
export const Event = (category, action, label) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label
  });
};